import { createContext } from 'react';
import { RouteData } from '@sitecore-jss/sitecore-jss-nextjs';

import { FlatTitledSitecoreItem } from '@gn-audio/jss-core';

import { MajorLink, SCMajorLinkCard, SubmenuItem } from '../../megaMenuTypes';

export interface IHeaderContext {
  onMenuItemClick?: (menuItem: SubmenuItem) => void;
  openMenuItem?: (menuItem: SubmenuItem) => void;
  onMobileMenuClick?: () => void;
  activeSubmenuItem?: SubmenuItem;
  menuItems: SubmenuItem[];
  isMobileMenuOpen: boolean;
  shouldFocus: boolean;
  activeItemId: string;
  onBackClick?: () => void;
  activeMajorLink: MajorLink | null;
  onMajorCategoryHover?: (majorLink: FlatTitledSitecoreItem<MajorLink>) => void;
  closeMenu: () => void;
  currentLocale: string;
  onLanguageSelect?: () => void;
  mediaHost: string;
  myJabraUrl?: string;
  route?: RouteData;
  cards?: Record<string, SCMajorLinkCard>;
}

const HeaderContext = createContext<IHeaderContext>({
  menuItems: [],
  isMobileMenuOpen: false,
  shouldFocus: false,
  activeItemId: '',
  activeMajorLink: null,
  closeMenu: () => null,
  currentLocale: 'en',
  mediaHost: '',
  myJabraUrl: '',
});

export { HeaderContext };
